<template>
  <main>
    <b-container v-if="apiReady">
      <div class="section-header">
        <h1 class="heading">Export Data</h1>

        <div class="actions">
          <div class="action">
            <b-btn @click="download()" variant="primary"
              >Export &amp; Downlaod</b-btn
            >
          </div>
        </div>
      </div>

      <b-alert show class="mb-5 mt-3">
        Showing exportable data. Please review all the content shown below.
      </b-alert>

      <b-row>
        <b-col cols="6" class="mb-4">
          <div class="section-header">
            <h1 class="heading">Projects</h1>

            <div class="actions">
              <div class="action"></div>
            </div>
          </div>
          <b-list-group>
            <b-list-group-item v-for="p in exportData.projects" :key="p._id">
              <b>{{ p.name }}</b> with Models
              <b-badge v-for="m in p.projectModels" :key="m._id" class="mr-1">{{
                m.name
              }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col cols="6" class="mb-4">
          <div class="section-header">
            <h1 class="heading">Filters</h1>

            <div class="actions">
              <div class="action"></div>
            </div>
          </div>
          <b-list-group v-for="c in filters" :key="c._id">
            <b-list-group-item v-for="sc in c.children" :key="sc._id"
              ><b>{{ c.name }} -> {{ sc.name }}</b> with Filters
              <b-badge v-for="f in sc.children" :key="f._id" class="mr-1">{{
                f.name
              }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col cols="6" class="mb-4">
          <div class="section-header">
            <h1 class="heading">Pools</h1>

            <div class="actions">
              <div class="action"></div>
            </div>
          </div>
          <b-list-group>
            <b-list-group-item v-for="p in exportData.pools" :key="p._id"
              ><b>{{ p.name }}</b> with Files
              <b-badge v-for="f in p.uploaddata" :key="f._id" class="mr-1">{{
                f._id.split("/")[f._id.split("/").length - 1]
              }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col cols="6" class="mb-4">
          <div class="section-header">
            <h1 class="heading">Analysis</h1>

            <div class="actions">
              <div class="action"></div>
            </div>
          </div>
          <b-list-group>
            <b-list-group-item v-for="a in analyses" :key="a._id"
              ><b>{{ a.name }}</b>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col cols="6" class="mb-4">
          <div class="section-header">
            <h1 class="heading">Other</h1>

            <div class="actions">
              <div class="action"></div>
            </div>
          </div>
          <b-list-group>
            <b-list-group-item
              >Working History + Saved Settings</b-list-group-item
            >
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import InitApi from "../Shared/InitApi";

export default {
  name: "Export",
  extends: InitApi,
  data() {
    return {
      exportData: {
        projects: [],
        pools: [],
        filters: [],
        analysis: [],
        settings: null,
      },
    };
  },
  computed: {
    ...mapState({
      apiReady: (state) => state.api.apiReady,
      currentProjectName: (state) => state.api.currentProjectName,
      filters: (state) => state.filter.filters,
      analyses: (state) => state.analyse.analyses,
      settings: (state) => state.setting.dataSettings,
    }),
    ...mapGetters(["poolsByDateDesc"]),
  },
  mounted() {
    this.loadExportData();
  },
  methods: {
    ...mapActions([
      "loadProjects",
      "loadProjectModels",
      "loadPools",
      "loadFilters",
      "loadAnalyses",
    ]),
    loadExportData() {
      this.loadPools().then(() => {
        this.loadProjects().then((projs) => {
          projs.forEach((proj) => {
            if (proj.name === this.currentProjectName) {
              this.loadProjectModels({ id: proj._id }).then((models) => {
                proj.projectModels = models;
                proj.projectModels.forEach((model) => {
                  let pool = this.poolsByDateDesc.filter(
                    (p) => p._id === model.pools[0].pool_id
                  );
                  this.exportData.pools.push(pool[0]);
                });
              });
              this.exportData.projects.push(proj);
            }
          });
        });
      });
      this.loadFilters().then(() => {
        this.exportData.filters = this.filters;
      });
      this.loadAnalyses().then(() => {
        this.exportData.analysis = this.analyses;
      });
      this.exportData.settings = this.settings;
    },
    download() {
      // credit: https://www.bitdegree.org/learn/javascript-download
      let stamp = Date.now() / 1000;
      let text = JSON.stringify(this.exportData);
      let filename = "export" + stamp + ".json";
      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:application/json;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();
      document.body.removeChild(element);
    },
  },
};
</script>